var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShowPasswordIcon = function SvgShowPasswordIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    fillRule: "evenodd",
    d: "M14.782 5.038c-1.423-1.107-3.057-1.705-4.78-1.705h-.009c-3.439 0-6.536 2.4-8.276 6.424a.6.6 0 0 0 0 .477c1.74 4.024 4.837 6.433 8.276 6.433h.008c3.448 0 6.545-2.409 8.285-6.433a.6.6 0 0 0 0-.477c-.87-2.012-2.081-3.62-3.504-4.719M6.749 10a3.24 3.24 0 0 1 3.252-3.232A3.24 3.24 0 0 1 13.245 10c0 1.778-1.455 3.224-3.244 3.224-1.796 0-3.252-1.446-3.252-3.224m5.278-.002c0-1.115-.91-2.02-2.025-2.02-.097 0-.195.008-.284.024a1.664 1.664 0 0 1-1.667 1.6h-.04a2 2 0 0 0-.041.396c0 1.107.91 2.012 2.032 2.012a2.024 2.024 0 0 0 2.025-2.012",
    clipRule: "evenodd"
  })));
};
export default SvgShowPasswordIcon;